<template>
  <div class="rankWorkTable">
    <div class="export fr">
      <img src="../../assets/img/exportExcel.png" alt="">
      <span>
        <a :href='exportUrl'>导出成绩</a>
      </span>
    </div>
    <div class="workTable">
      <table border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
        <thead>
          <tr>
            <th>排名</th>
            <th>姓名</th>
            <th v-for="(item,index) in collectHeader" :key="index">
              <p>{{item.name}}</p>
              <span class="score">{{item.score}}分</span>
            </th>
            <th>
              <p>总分</p>
              <span class="score">{{workScore.score}}分</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in collectData" :key="index">
            <td>{{index + 1}}</td>
            <td>{{item.userName}}</td>
            <td v-for="(items, index) in item.tabDatas" :key="index">
              <span v-if="items.moduleId != 66">{{items.score}}</span>
              <span v-if="items.moduleId == 66 && items.submitStatus.hasQuestion && items.submitStatus.isSubmit">{{items.score}}</span>
              <span v-else-if="items.moduleId == 66 && !items.submitStatus.hasQuestion && items.submitStatus.isSubmit">{{'已提交' || '未提交'}}</span>
            </td>
            <td>{{item.totalScore || 0}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script type="text/javascript">
import { clientId, brandId, http } from "./../../config";
export default {
  props: ["collectHeader", "collectData", "workScore", "url"],
  data() {
    return {
      exportUrl: ""
    };
  },
  created() {
    let workId = this.$route.query.workId;
    let user = JSON.parse(window.localStorage.getItem('user'))
    let url =
      http +
      "/gateway/v1/epaperstatistics/exportWorkReport?" +
      "clientId=" +
      clientId + 
      "&accessToken=" +
      user.accessToken +
      "&workId=" +
      workId;
    this.exportUrl = url;
  }
};
</script>



// WEBPACK FOOTER //
// rankWorkTable.vue?08a2129d